import React from 'react';
import '../css/activities.css';

const activityImages = {
  rainDance: '/images/destination/01.jpg',
  archery: '/images/destination/02.jpg',
  bullRiding: '/images/destination/03.jpg',
  birdWatching: '/images/destination/04.jpg',
  swimmingPool: '/images/destination/05.jpg',
  campfire: '/images/destination/06.jpg',
  addcampfire: '/images/destination/07.jpg',
  puppet: '/images/destination/08.jpg',
  afvs: '/images/destination/09.jpg',
  dance: '/images/destination/10.jpg',
  adventure: '/images/destination/11.jpg',
  shivar: '/images/destination/12.jpg',
};

const Activities = () => {
  const activities = [
    {
      title: 'Farm Stays',
      icon: 'icon-water',
      description: 'Experience the tranquility of rural life with our comfortable and authentic farm stays. Immerse yourself in the serene ambiance of our picturesque farmland, where you can relax and rejuvenate amidst nature"s embrace',
      image: activityImages.rainDance,
    },
    {
      title: 'Peacock Watching',
      icon: 'icon-archery',
      description: 'Morachi Chincholi is known for its large population of peacocks. Visitors can spend time observing these majestic birds in their natural habitat. You can see them roaming freely around the village, displaying their vibrant plumage and engaging in their natural behaviors.',
      image: activityImages.archery,
    },    
    {
      title: 'Photography',
      icon: 'icon-bullhorn',
      description: 'Capture stunning photographs of peacocks against the backdrop of rural Maharashtra. With their striking colors and graceful movements, peacocks offer excellent photo opportunities for wildlife enthusiasts and photographers alike.',
      image: activityImages.bullRiding,
    },
    {
      title: 'Peacock Feeding',
      icon: 'icon-bird',
      description: 'Some places in Morachi Chincholi offer the opportunity to feed peacocks. Visitors can interact with these beautiful birds by offering them grains or bird feed, providing a closer encounter with these magnificent creatures.',
      image: activityImages.birdWatching,
    },
    {
      title: 'Peacock Dance',
      icon: 'icon-swimming-pool',
      description: 'Witness the mesmerizing dance of peacocks during their mating season, typically from July to September. Male peacocks display their elaborate courtship dance, spreading their feathers in a breathtaking display to attract females. It is a captivating sight to behold and a highlight of any visit to Morachi Chincholi.',
      image: activityImages.swimmingPool,
    },
    {
      title: 'Tractor or Bullock Cart and Horse Rides',
      icon: 'icon-swimming-pool',
      description: '"Relive the charm of rural transportation with our tractor, bullock cart rides and Horse ride. Enjoy a leisurely journey through the countryside, soaking in the scenic beauty and rustic charm of Morachi Chincholi."',
      image: activityImages.campfire,
    },
     {
      title: 'Hurda Party',
      icon: 'icon-swimming-pool',
      description: '"Indulge in the flavors of the season with our festive Hurda Party celebrations. Taste the freshly roasted hurda, a delicacy made from tender sorghum grains, and immerse yourself in the vibrant festivities of rural Maharashtra."',
      image: activityImages.addcampfire,
    },
     {
      title: 'Puppet Show',
      icon: 'icon-swimming-pool',
      description: '"Experience the magic of traditional puppetry with our captivating puppet shows. Delight in the colorful performances that showcase age-old tales and folklore, providing entertainment for the whole family."',
      image: activityImages.puppet,
    },
     {
      title: 'Mango Mahotsav',
      icon: 'icon-swimming-pool',
      description: '"Celebrate the king of fruits with our Mango Mahotsav festivities. Enjoy a delectable array of mango-based delicacies, participate in mango picking, and indulge in the sweet flavors of the season."',
      image: activityImages.afvs,
    },
     {
      title: 'Rain Dance & DJ Music',
      icon: 'icon-swimming-pool',
      description: '"Beat the heat and groove to the rhythm of DJ music with our exhilarating rain dance parties. Let loose and dance under the open sky as refreshing water showers create an electrifying atmosphere."',
      image: activityImages.dance,
    },
     {
      title: 'Adventure Games',
      icon: 'icon-swimming-pool',
      description: '"Embark on adrenaline-pumping adventures with our thrilling adventure games. Test your skills and courage with activities like zip-lining, rock climbing, and obstacle courses set amidst the natural beauty of our countryside."',
      image: activityImages.adventure,
    },
         {
      title: 'Shivar Feri',
      icon: 'icon-swimming-pool',
      description: '"At Anand Krishi Paryatan Kendra Morachi Chincholi, we are proud of our big fruit farms, lots of different crops, and gardens full of medicinal plants. Our place is great for learning about farming and enjoying nature in Maharashtra."',
      image: activityImages.shivar,
    },

  ];

  return (
    <div>
      <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
        <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
        <div className="breadcrumb-outer">
          <div className="container">
            <div className="breadcrumb-content text-center">
              <h2 className="mb-3 text-white">Activities</h2>
            </div>
          </div>
        </div>
        <div className="dot-overlay"></div>
      </section>

      <section className="activities-section py-5">
        <div className="container">
          <h2 className="mb-4 text-center">Exciting Activities at Anand Krishi Paryatan</h2>
          <p className="mb-3 text-center">Enjoy a range of fun-filled activities that bring you closer to nature and farm life!</p>

          <div className="row">
            {activities.map((activity, index) => (
              <div className="col-lg-6 mb-4" key={index}>
                <div className="activity-card d-flex flex-column flex-lg-row">
                  <div className="activity-image">
                    <img src={activity.image} alt={activity.title} className="img-fluid rounded" />
                  </div>
                  <div className="activity-content ps-lg-4 pt-3 pt-lg-0">
                    <h5><i className={`${activity.icon} theme`}></i> {activity.title}</h5>
                    <p>{activity.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Activities;
